import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { usePrismaContext } from '../../context/PrismaContext';

const MobileMenu = ({ currentCategory, onNavigateHome, onNavigateCategory, categories, isOpen, onClose }) => {
    const { getCategoryName, getNavigationLabel } = usePrismaContext();

    return (
        <Drawer
            variant="temporary"
            anchor="right"
            open={isOpen}
            onClose={onClose}
            ModalProps={{ keepMounted: true }}
            sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 280 },
            }}
        >
            <Box sx={{ width: 280, height: '100%' }}>
                {/* Header del drawer */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        p: 2,
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontSize: 18,
                            fontWeight: 600,
                            cursor: 'pointer',
                            '&:hover': { opacity: 0.7 },
                        }}
                        onClick={() => {
                            onNavigateHome();
                            onClose();
                        }}
                    >
                        {getNavigationLabel('inicio')}
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Lista de navegación */}
                <List sx={{ pt: 2 }}>
                    {/* Categorías */}
                    {categories.map(({ id }) => {
                        const isActive = currentCategory === id;

                        return (
                            <ListItemButton
                                key={id}
                                onClick={() => {
                                    onNavigateCategory(id);
                                    onClose();
                                }}
                                sx={{
                                    mb: 0.5,
                                    mx: 2,
                                    borderRadius: 1,
                                    backgroundColor: isActive ? 'primary.main' : 'transparent',
                                    color: isActive ? 'white' : 'inherit',
                                    '&:hover': {
                                        backgroundColor: 'primary.main',
                                        color: 'white',
                                    },
                                }}
                            >
                                <ListItemText primary={getCategoryName(id)} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </Box>
        </Drawer>
    );
};

export default MobileMenu;
